import PropTypes from 'prop-types';
import { memo } from 'react';

import Breadcrumb from 'shopper/components/Breadcrumb';
import Icon from 'shopper/components/Icon';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import { toCategoryLink, toSubcategoryLink } from 'lib/links';
import { sliceWithEllipsis } from 'lib/string';

import LINKS from 'constants/links';

const OFFER_TITLE_CHAR_LIMIT = 48;

const OfferBreadcrumb = ({
  categoryName,
  categorySlug,
  offerTitle = null,
  subcategoryName = null,
  subcategorySlug,
}) => (
  <Breadcrumb>
    <BreadcrumbItem
      className="text-sm text-experimental-blue dark:text-experimental-blue md:text-base"
      href={LINKS.HOME}
    >
      <Icon
        className="text-experimental-blue dark:text-experimental-blue"
        name="home"
      />
    </BreadcrumbItem>
    <BreadcrumbItem
      className="text-sm text-experimental-blue dark:text-experimental-blue md:text-base"
      href={toCategoryLink(categorySlug)}
    >
      {categoryName}
    </BreadcrumbItem>
    {subcategoryName && (
      <BreadcrumbItem
        className="text-sm text-experimental-blue dark:text-experimental-blue md:text-base"
        href={toSubcategoryLink(subcategorySlug)}
      >
        {subcategoryName}
      </BreadcrumbItem>
    )}
    {offerTitle && (
      <BreadcrumbItem className="text-sm md:text-base">
        {sliceWithEllipsis(offerTitle, OFFER_TITLE_CHAR_LIMIT)}
      </BreadcrumbItem>
    )}
  </Breadcrumb>
);

OfferBreadcrumb.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  offerTitle: PropTypes.string,
  subcategoryName: PropTypes.string,
  subcategorySlug: PropTypes.string.isRequired,
};

export default memo(OfferBreadcrumb);
